export const gamesData = [
  {
    "id": "1",
    "title": "Tomb Runner",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Endless runner game where players dash through temples, collect coins, and dodge traps.",
    "thumbnail": "/thumbnails/game-1.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/tomb-runner/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1100
  },
  {
    "id": "2",
    "title": "Temple Quest",
    "category": "adventure",
    "genre": "Adventure",
    "description": "Adventure-based runner game through mystical temples with increasing challenges.",
    "thumbnail": "/thumbnails/game-2.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/temple-quest/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2628
  },
  {
    "id": "3",
    "title": "Xtreme Dennis",
    "category": "racing",
    "genre": "Racing/Action",
    "description": "Perform extreme sports challenges with Dennis.",
    "thumbnail": "/thumbnails/game-3.jpg",
    "url": "https://lib.gamesmotion.fun/xtreme-dennis",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1328
  },
  {
    "id": "4",
    "title": "Incredible Hulk: Chitauri Takedown",
    "category": "arcade",
    "genre": "Action/Beat 'em Up",
    "description": "Smash enemies and save the city as the Hulk.",
    "thumbnail": "/thumbnails/game-4.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/incredible-hulk-chitauri-takedown/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2202
  },
  {
    "id": "5",
    "title": "Rusty Rivets: Jungle Rescue",
    "category": "puzzle",
    "genre": "Adventure/Puzzle",
    "description": "Help Rusty navigate through the jungle to complete missions.",
    "thumbnail": "/thumbnails/game-5.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/rusty-rivets-jungle-rescue/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2362
  },
  {
    "id": "6",
    "title": "Rusty Rivets: Rusty Dives In",
    "category": "platform",
    "genre": "Action/Platformer",
    "description": "Explore underwater world solving problems with Rusty.",
    "thumbnail": "/thumbnails/game-6.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/rusty-rivets-rusty-dives-in/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1236
  },
  {
    "id": "7",
    "title": "Lightning Speed",
    "category": "arcade",
    "genre": "Racing/Arcade",
    "description": "High-speed racing with turbo boosts and power-ups.",
    "thumbnail": "/thumbnails/game-7.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/lightning-speed/index.html",
    "orientation": "vetical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2724
  },
  {
    "id": "8",
    "title": "X-Wing Fighter",
    "category": "arcade",
    "genre": "Arcade",
    "description": "Space shooter game piloting the classic X-Wing.\t",
    "thumbnail": "/thumbnails/game-8.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/x-wing-fighter/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2555
  },
  {
    "id": "8",
    "title": "Summer Games",
    "category": "arcade",
    "genre": "Sports/Mini-games",
    "description": "Compete in mini-Olympic events like sprints and swimming.",
    "thumbnail": "/thumbnails/game-8.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/summer-games/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1027
  },
  {
    "id": "9",
    "title": "All-Star Clash",
    "category": "arcade",
    "genre": "Fighting/Sports",
    "description": "Multiplayer battle arena featuring various characters in competitive matchups.",
    "thumbnail": "/thumbnails/game-9.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/all-star-clash/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1655
  },
  {
    "id": "10",
    "title": "Beach City Drifters",
    "category": "racing",
    "genre": "Racing/Casual",
    "description": "Racing game set in a beach town with stylish cars and fast-paced action.",
    "thumbnail": "/thumbnails/game-10.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/beach-city-drifters/index.html",
    "orientation": "vetical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2043
  },
  {
    "id": "11",
    "title": "Bunnicula & the Cursed Diamond",
    "category": "arcade",
    "genre": "Adventure/Mystery",
    "description": "Help Bunnicula retrieve a stolen cursed diamond while avoiding traps and monsters.",
    "thumbnail": "/thumbnails/game-11.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/bunnicula-and-the-cursed-diamond/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2362
  },
  {
    "id": "12",
    "title": "Bunnicula: Crop Control",
    "category": "arcade",
    "genre": "Tower Defense/Strategy",
    "description": "Players help Bunnicula protect veggies from pests using power-ups and tactics.",
    "thumbnail": "/thumbnails/game-12.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/Bunnicula-CropControl/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2540
  },
  {
    "id": "13",
    "title": "Bunnicula: Kaotic Kitchen",
    "category": "arcade",
    "genre": "Time Management/Cooking",
    "description": "Players dodge food monsters in a crazy kitchen scenario with Bunnicula.",
    "thumbnail": "/thumbnails/game-13.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/bunnicula-kaotic-kitchen/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2018
  },
  {
    "id": "14",
    "title": "Bunnicula: Monster Match",
    "category": "arcade",
    "genre": "Match-3/Puzzle",
    "description": "Match-3 puzzle game involving spooky yet fun characters from the Bunnicula series.",
    "thumbnail": "/thumbnails/game-14.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/bunnicula-monster-match/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1596
  },
  {
    "id": "15",
    "title": "Bunnicula: Rescuing Harold",
    "category": "puzzle",
    "genre": "Adventure/Puzzle",
    "description": "Help Bunnicula save Harold from traps using logic and timing.",
    "thumbnail": "/thumbnails/game-15.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/bunnicula-rescuing-harold/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2297
  },
  {
    "id": "16",
    "title": "Bunnicula: Splash Art",
    "category": "arcade",
    "genre": "Art/Creative",
    "description": "Color and draw scenes featuring Bunnicula and friends.",
    "thumbnail": "/thumbnails/game-16.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/bunnicula-splash-art/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2380
  },
  {
    "id": "17",
    "title": "Cabbage Catch",
    "category": "arcade",
    "genre": "Arcade/Casual",
    "description": "Catch falling cabbages quickly without missing.",
    "thumbnail": "/thumbnails/game-17.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/cabbage-catch/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2680
  },
  {
    "id": "18",
    "title": "Cannons and Soldiers",
    "category": "arcade",
    "genre": "Strategy/Action",
    "description": "Use physics to destroy enemies with strategic cannon shots.",
    "thumbnail": "/thumbnails/game-18.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/cannons-and-soldiers/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2908
  },
  {
    "id": "19",
    "title": "Cliff Diving",
    "category": "arcade",
    "genre": "Sports/Simulation",
    "description": "Perform stunts and dives off cliffs for score.",
    "thumbnail": "/thumbnails/game-19.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/cliff-diving/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1696
  },
  {
    "id": "20",
    "title": "CTB: Wobbly Dad",
    "category": "arcade",
    "genre": "Party/Multiplayer",
    "description": "Control a wobbly dad in a physics-based comedy setup.",
    "thumbnail": "/thumbnails/game-20.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/ctb-wobbly-dad/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2080
  },
  {
    "id": "21",
    "title": "Defend the Sewers",
    "category": "puzzle",
    "genre": "Tower Defense",
    "description": "Defend your sewer base from enemies with gadgets.",
    "thumbnail": "/thumbnails/game-21.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/defend-the-sewers/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2727
  },
  {
    "id": "22",
    "title": "Dorothy & the Wizard of Oz: Cookie Magic",
    "category": "puzzle",
    "genre": "Puzzle/Adventure",
    "description": "Solve puzzles by matching cookies in Oz-themed world.",
    "thumbnail": "/thumbnails/game-22.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/dorothy-and-the-wizard-of-oz-cookie-magic/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1180
  },
  {
    "id": "23",
    "title": "Fabulosos Fantastic Flight",
    "category": "arcade",
    "genre": "Endless Runner",
    "description": "Fly and collect stars while avoiding obstacles.",
    "thumbnail": "/thumbnails/game-23.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/fabulosos-fantastic-flight/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1092
  },
  {
    "id": "24",
    "title": "Fishing",
    "category": "arcade",
    "genre": "Simulation/Casual",
    "description": "Cast, catch, and upgrade gear in a relaxing environment.",
    "thumbnail": "/thumbnails/game-24.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/fishing/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1872
  },
  {
    "id": "25",
    "title": "We Bare Bears: Baby Bear Bonanza",
    "category": "arcade",
    "genre": "Casual/Collection",
    "description": "Play as baby bears in fun mini-games.",
    "thumbnail": "/thumbnails/game-25.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/we-bare-bears-baby-bear-bonanza/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1343
  },
  {
    "id": "26",
    "title": "We Bare Bears: Beary Rapids",
    "category": "racing",
    "genre": "Racing/Adventure",
    "description": "Navigate water rapids with reflex-based challenges.",
    "thumbnail": "/thumbnails/game-26.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/we-bare-bears-beary-rapids/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2888
  },
  {
    "id": "27",
    "title": "We Bare Bears: Feathered Chase",
    "category": "arcade",
    "genre": "Endless Runner",
    "description": "Chase a mischievous bird through platforming levels.",
    "thumbnail": "/thumbnails/game-27.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/we-bare-bears-feathered-chase/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2977
  },
  {
    "id": "28",
    "title": "We Bare Bears: Polar Force",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Use martial arts with Ice Bear to fight enemies.",
    "thumbnail": "/thumbnails/game-28.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/we-bare-bears-polar-force/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2592
  },
  {
    "id": "29",
    "title": "We Bare Bears: Scooter Streamers",
    "category": "racing",
    "genre": "Racing/Casual",
    "description": "Ride scooters while collecting likes and avoiding traffic.",
    "thumbnail": "/thumbnails/game-29.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/we-bare-bears-scooter-streamers/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2690
  },
  {
    "id": "30",
    "title": "We Bare Bears: Shush Ninjas",
    "category": "action",
    "genre": "Stealth/Action",
    "description": "Quiet noisy moviegoers using stealth tactics.",
    "thumbnail": "/thumbnails/game-30.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/we-bare-bears-shush-ninjas/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2371
  },
  {
    "id": "31",
    "title": "Table Tennis: Ultra Mega Tournament",
    "category": "arcade",
    "genre": "Sports/Arcade",
    "description": "Competitive table tennis game with special moves and multiplayer mode.",
    "thumbnail": "/thumbnails/game-31.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/table-tennis-ultra-mega-tournament/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1852
  },
  {
    "id": "32",
    "title": "Space Scouts: Home Base",
    "category": "adventure",
    "genre": "Simulation/Adventure",
    "description": "Manage and expand a space colony while completing missions.",
    "thumbnail": "/thumbnails/game-32.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/space-scouts-home-base/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2467
  },
  {
    "id": "33",
    "title": "Off-Road Climber",
    "category": "racing",
    "genre": "Racing/Simulation",
    "description": "Drive 4x4 vehicles through rugged terrain.",
    "thumbnail": "/thumbnails/game-33.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/off-road-climber/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1844
  },
  {
    "id": "34",
    "title": "Hydro Blast",
    "category": "puzzle",
    "genre": "Strategy",
    "description": "Use water cannons to clear obstacles and enemies.",
    "thumbnail": "/thumbnails/game-34.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/hydro-blast/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1499
  },
  {
    "id": "35",
    "title": "My Knight and Me: Bouncing Princesses",
    "category": "platform",
    "genre": "Platformer/Adventure",
    "description": "Help the princess bounce safely through obstacles.",
    "thumbnail": "/thumbnails/game-35.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/my-knight-and-me-bouncing-princesses/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2964
  },
  {
    "id": "36",
    "title": "Adventure Time: Fionna Fights",
    "category": "action",
    "genre": "Action/RPG",
    "description": "Fight off waves of enemies as Fionna from Adventure Time.",
    "thumbnail": "/thumbnails/game-36.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/adventure-time-fionna-fights/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2795
  },
  {
    "id": "37",
    "title": "Rusty Rivets: Flip and Match",
    "category": "puzzle",
    "genre": "Puzzle/Memory",
    "description": "Match pairs with Rusty and Ruby.",
    "thumbnail": "/thumbnails/game-37.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/rusty-rivets-flip-and-match/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2893
  },
  {
    "id": "38",
    "title": "Teen Titans Go! Storyboard Game",
    "category": "puzzle",
    "genre": "Puzzle/Creative",
    "description": "Build your own story scene-by-scene.",
    "thumbnail": "/thumbnails/game-38.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/teen-titans-go!-the-close-ups-quiz/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2540
  },
  {
    "id": "39",
    "title": "Teen Titans Goal!",
    "category": "arcade",
    "genre": "Sports/Arcade",
    "description": "Soccer-style game with TTG characters.",
    "thumbnail": "/thumbnails/game-39.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/teen-titans-goal-do-not-publish/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1327
  },
  {
    "id": "40",
    "title": "Teen Titans Go: Jump Jousts",
    "category": "action",
    "genre": "Fighting/Party",
    "description": "Combat-based platformer with jumping duels.",
    "thumbnail": "/thumbnails/game-40.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/teen-titans-go-jump-jousts/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2282
  },
  {
    "id": "41",
    "title": "Teen Titans Go: Robin vs. See-More",
    "category": "action",
    "genre": "Fighting/Action",
    "description": "One-on-one battle featuring Robin.",
    "thumbnail": "/thumbnails/game-41.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/teen-titans-go-robin-vs-see-more/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1416
  },
  {
    "id": "42",
    "title": "Teen Titans Go: Rock 'n' Raven",
    "category": "arcade",
    "genre": "Music/Rhythm",
    "description": "Help Raven complete musical platforming challenges.",
    "thumbnail": "/thumbnails/game-42.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/teen-titans-go-rock-n-raven/index.html",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2316
  },
  {
    "id": "43",
    "title": "Teen Titans Go: Rumble Bee",
    "category": "arcade",
    "genre": "Action/Arcade",
    "description": "Buzz through enemies as Bumblebee.",
    "thumbnail": "/thumbnails/game-43.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/teen-titans-go-rumble-bee/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2958
  },
  {
    "id": "44",
    "title": "Teen Titans Go: Super Hero Maker",
    "category": "arcade",
    "genre": "Creative/Dress-up",
    "description": "Design your own TTG superhero.",
    "thumbnail": "/thumbnails/game-44.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/teen-titans-go-super-hero-maker/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2778
  },
  {
    "id": "45",
    "title": "Teen Titans Go: Zapping Run",
    "category": "arcade",
    "genre": "Endless Runner",
    "description": "Run and zap enemies while collecting points.",
    "thumbnail": "/thumbnails/game-45.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/teen-titans-go-zapping-run/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1626
  },
  {
    "id": "46",
    "title": "Teen Titans: Ninja Run",
    "category": "platform",
    "genre": "Action/Platformer",
    "description": "Stealthy endless runner in a ninja theme.",
    "thumbnail": "/thumbnails/game-46.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/teen-titans-ninja-run/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2053
  },
  {
    "id": "47",
    "title": "The Powerpuff Girls: Colour-In Game",
    "category": "arcade",
    "genre": "Art/Casual",
    "description": "Color scenes from Powerpuff world.",
    "thumbnail": "/thumbnails/game-47.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/the-powerpuff-girls-colour-in-game/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1354
  },
  {
    "id": "48",
    "title": "The Powerpuff Girls: Hypno Bliss",
    "category": "puzzle",
    "genre": "Puzzle/Mind-Bending",
    "description": "Rescue town from hypnotized citizens.",
    "thumbnail": "/thumbnails/game-48.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/the-powerpuff-girls-hypno-bliss/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2380
  },
  {
    "id": "49",
    "title": "The Powerpuff Girls: Mech Mayhem",
    "category": "action",
    "genre": "Action/Shooter",
    "description": "Battle evil robots using teamwork.",
    "thumbnail": "/thumbnails/game-49.png",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/the-powerpuff-girls-mech-mayhem/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1228
  },
  {
    "id": "50",
    "title": "The Powerpuff Girls: Morning Mix-Up",
    "category": "puzzle",
    "genre": "Time Management",
    "description": "Solve morning routine puzzles with the girls.",
    "thumbnail": "/thumbnails/game-50.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/the-powerpuff-girls-morning-mix-up/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2274
  },
  {
    "id": "51",
    "title": "The Powerpuff Girls: Storyboard Game",
    "category": "puzzle",
    "genre": "Creative/Puzzle",
    "description": "Craft your own animated PPG stories.",
    "thumbnail": "/thumbnails/game-51.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/the-powerpuff-girls-storyboard-game/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1745
  },
  {
    "id": "52",
    "title": "Power Puff Girls: Morning Mayhem",
    "category": "arcade",
    "genre": "Simulation/Chaos",
    "description": "Manage chaos before school begins.",
    "thumbnail": "/thumbnails/game-52.jpeg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/power-puff-girls-morning-mayhem/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2347
  },
  {
    "id": "53",
    "title": "Powerpuff Girls: Panic in Townsville",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Fight off waves of villains threatening Townsville.",
    "thumbnail": "/thumbnails/game-53.jpg",
    "url": "https://games-fg.s3.us-east-2.amazonaws.com/branded/powerpuff-girls-panic-in-townsville/index.html",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1781
  },
  {
    "id": "54",
    "title": "Star Wars Rogue One Boots On The Ground",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Tactical shooting game based on Rogue One missions.",
    "thumbnail": "/thumbnails/game-54.png",
    "url": "https://lib.gamesmotion.fun/star-wars-rogue-one-boots-on-the-ground",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2093
  },
  {
    "id": "55",
    "title": "Freefalling Tom",
    "category": "arcade",
    "genre": "Arcade/Adventure",
    "description": "Help Tom descend safely while avoiding obstacles.",
    "thumbnail": "/thumbnails/game-55.png",
    "url": "https://lib.gamesmotion.fun/freefalling-tom",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2504
  },
  {
    "id": "56",
    "title": "Scooby Doo And Guess Midnight Munchies",
    "category": "puzzle",
    "genre": "Puzzle/Adventure",
    "description": "Solve mini-puzzles to help Scooby get snacks.",
    "thumbnail": "/thumbnails/game-56.jpg",
    "url": "https://lib.gamesmotion.fun/scooby-doo-and-guess-midnight-munchies",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2737
  },
  {
    "id": "57",
    "title": "Teen Titans Go Super Hero Maker",
    "category": "adventure",
    "genre": "Adventure/Creative",
    "description": "Create your own superhero with Teen Titans elements.",
    "thumbnail": "/thumbnails/game-57.png",
    "url": "https://lib.gamesmotion.fun/teen-titans-go-super-hero-maker",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2651
  },
  {
    "id": "58",
    "title": "Tom And Jerry Cheese Swipe",
    "category": "puzzle",
    "genre": "Puzzle/Arcade",
    "description": "Jerry collects cheese while dodging Tom.",
    "thumbnail": "/thumbnails/game-58.jpg",
    "url": "https://lib.gamesmotion.fun/tom-and-jerry-cheese-swipe",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1409
  },
  {
    "id": "59",
    "title": "Danger Mouse 2 Full Speed",
    "category": "racing",
    "genre": "Racing/Adventure",
    "description": "High-speed racing and obstacle dodging.",
    "thumbnail": "/thumbnails/game-59.png",
    "url": "https://lib.gamesmotion.fun/danger-mouse-2-full-speed",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2058
  },
  {
    "id": "60",
    "title": "Run Pixie Run",
    "category": "arcade",
    "genre": "Endless Runner/Arcade",
    "description": "Magical pixie runs through obstacles in a vibrant world.",
    "thumbnail": "/thumbnails/game-60.png",
    "url": "https://lib.gamesmotion.fun/run-pixie-run",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1700
  },
  {
    "id": "61",
    "title": "X Wing Fighter",
    "category": "arcade",
    "genre": "Shooter/Action",
    "description": "Space shooter game piloting the classic X-Wing.",
    "thumbnail": "/thumbnails/game-61.png",
    "url": "https://lib.gamesmotion.fun/x-wing-fighter",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2062
  },
  {
    "id": "63",
    "title": "Star Wars Rebels Special Ops",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Side-scrolling combat with Rebels characters.",
    "thumbnail": "/thumbnails/game-63.png",
    "url": "https://lib.gamesmotion.fun/star-wars-rebels-special-ops",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2721
  },
  {
    "id": "64",
    "title": "The Powerpuff Girls Hypno Bliss",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Platform game to save Bliss from hypnosis.",
    "thumbnail": "/thumbnails/game-64.png",
    "url": "https://lib.gamesmotion.fun/the-powerpuff-girls-hypno-bliss",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2780
  },
  {
    "id": "65",
    "title": "Spider Man Games Masked Missions Game",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Fight crime and swing through the city.",
    "thumbnail": "/thumbnails/game-65.png",
    "url": "https://lib.gamesmotion.fun/spider-man-games-masked-missions-game",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1572
  },
  {
    "id": "66",
    "title": "Be Cool Scooby Doo No Guts No Treats",
    "category": "puzzle",
    "genre": "Adventure/Puzzle",
    "description": "Scooby navigates spooky platformer levels.",
    "thumbnail": "/thumbnails/game-66.png",
    "url": "https://lib.gamesmotion.fun/be-cool-scooby-doo-no-guts-no-treats",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2315
  },
  {
    "id": "67",
    "title": "Uncle Grand Vs Aunt Grandma",
    "category": "action",
    "genre": "Action/Fighting",
    "description": "Quirky battle with fun mini-games.",
    "thumbnail": "/thumbnails/game-67.png",
    "url": "https://lib.gamesmotion.fun/uncle-grand-vs-aunt-grandma",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2192
  },
  {
    "id": "68",
    "title": "Spider Man Mysterio Rush Game",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Chase Mysterio across the city.",
    "thumbnail": "/thumbnails/game-68.png",
    "url": "https://lib.gamesmotion.fun/spider-man-mysterio-rush-game",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1778
  },
  {
    "id": "69",
    "title": "Regular Show Rigbmx 2",
    "category": "racing",
    "genre": "Racing/Adventure",
    "description": "BMX stunts and racing with Rigby.",
    "thumbnail": "/thumbnails/game-69.jpeg",
    "url": "https://lib.gamesmotion.fun/regular-show-rigbmx-2",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2649
  },
  {
    "id": "70",
    "title": "Powerpuff Girls Panic In Townsville",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Stop chaos by catching falling items.",
    "thumbnail": "/thumbnails/game-70.png",
    "url": "https://lib.gamesmotion.fun/powerpuff-girls-panic-in-townsville",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2337
  },
  {
    "id": "71",
    "title": "Loud House Rockin Out Loud",
    "category": "arcade",
    "genre": "Rhythm/Music",
    "description": "Rhythm game featuring the Loud siblings.",
    "thumbnail": "/thumbnails/game-71.jpg",
    "url": "https://lib.gamesmotion.fun/loud-house-rockin-out-loud",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1478
  },
  {
    "id": "72",
    "title": "The Powerpuff Girls Mech Mayhem",
    "category": "action",
    "genre": "Action/Strategy",
    "description": "Mech-style fighting with Powerpuff Girls.",
    "thumbnail": "/thumbnails/game-72.jpg",
    "url": "https://lib.gamesmotion.fun/the-powerpuff-girls-mech-mayhem",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2187
  },
  {
    "id": "73",
    "title": "Adventure Time Angry Betty",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Help Finn and Jake stop an angry villain causing chaos.",
    "thumbnail": "/thumbnails/game-73.png",
    "url": "https://lib.gamesmotion.fun/adventure-time-angry-betty",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2417
  },
  {
    "id": "74",
    "title": "Ben 10 Power Surge",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Battle enemies and power up as different aliens.",
    "thumbnail": "/thumbnails/game-74.jpg",
    "url": "https://lib.gamesmotion.fun/ben-10-power-surge",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2294
  },
  {
    "id": "75",
    "title": "Tom Jerry Whats The Catch",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Catch or dodge items in a fast-paced chase.",
    "thumbnail": "/thumbnails/game-75.jpg",
    "url": "https://lib.gamesmotion.fun/tom-jerry-whats-the-catch",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2499
  },
  {
    "id": "76",
    "title": "Henry Danger Whats Your Danger Ous Power",
    "category": "adventure",
    "genre": "Quiz/Adventure",
    "description": "Interactive quiz-style game to reveal your superpower.",
    "thumbnail": "/thumbnails/game-76.png",
    "url": "https://lib.gamesmotion.fun/henry-danger-whats-your-danger-ous-power",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1811
  },
  {
    "id": "77",
    "title": "Treasure Rush",
    "category": "platform",
    "genre": "Adventure/Platformer",
    "description": "Run-and-jump game collecting treasures and avoiding traps.",
    "thumbnail": "/thumbnails/game-77.jpg",
    "url": "https://lib.gamesmotion.fun/treasure-rush",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1232
  },
  {
    "id": "78",
    "title": "We Bare Bears Baby Bear Bonanza",
    "category": "puzzle",
    "genre": "Adventure/Puzzle",
    "description": "Solve puzzles with the baby versions of the bears.",
    "thumbnail": "/thumbnails/game-78.jpg",
    "url": "https://lib.gamesmotion.fun/we-bare-bears-baby-bear-bonanza",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2370
  },
  {
    "id": "79",
    "title": "Grizzy And The Lemming",
    "category": "arcade",
    "genre": "Arcade/Adventure",
    "description": "Slapstick-style mini-games inspired by the show.",
    "thumbnail": "/thumbnails/game-79.jpg",
    "url": "https://lib.gamesmotion.fun/grizzy-and-the-lemming",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1930
  },
  {
    "id": "80",
    "title": "Tom And Jerry Parade Pranks",
    "category": "puzzle",
    "genre": "Puzzle/Adventure",
    "description": "Set pranks during a parade as Jerry avoids Tom.",
    "thumbnail": "/thumbnails/game-80.jpg",
    "url": "https://lib.gamesmotion.fun/tom-and-jerry-parade-pranks",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2529
  },
  {
    "id": "81",
    "title": "Road Riot Tmnt",
    "category": "racing",
    "genre": "Racing/Action",
    "description": "Drive and shoot enemies with the Ninja Turtles.",
    "thumbnail": "/thumbnails/game-81.jpg",
    "url": "https://lib.gamesmotion.fun/road-riot-tmnt",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1742
  },
  {
    "id": "82",
    "title": "Scooby Doo Its Dark Out There",
    "category": "puzzle",
    "genre": "Puzzle/Adventure",
    "description": "Navigate spooky dark environments to find clues.",
    "thumbnail": "/thumbnails/game-82.jpg",
    "url": "https://lib.gamesmotion.fun/scooby-doo-its-dark-out-there",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2455
  },
  {
    "id": "84",
    "title": "Yoda Jedi Training",
    "category": "action",
    "genre": "Adventure/Action",
    "description": "Learn Jedi skills through challenges and training.",
    "thumbnail": "/thumbnails/game-84.jpg",
    "url": "https://lib.gamesmotion.fun/yoda-jedi-training",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2576
  },
  {
    "id": "85",
    "title": "Adventure Time Elemental",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Platform game using elemental powers to defeat enemies.",
    "thumbnail": "/thumbnails/game-85.jpg",
    "url": "https://lib.gamesmotion.fun/adventure-time-elemental",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2998
  },
  {
    "id": "86",
    "title": "Ben 10 Hero Time Game",
    "category": "action",
    "genre": "Action/Adventure",
    "description": "Defeat villains and complete missions across levels.",
    "thumbnail": "/thumbnails/game-86.jpg",
    "url": "https://lib.gamesmotion.fun/ben-10-hero-time-game",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1528
  },
  {
    "id": "87",
    "title": "Gotham City Speed",
    "category": "racing",
    "genre": "Racing/Adventure",
    "description": "High-speed chase game through Gotham’s streets.",
    "thumbnail": "/thumbnails/game-87.jpg",
    "url": "https://lib.gamesmotion.fun/gothamcityspeed",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2223
  },
  {
    "id": "88",
    "title": "Power Puff Girls Morning Mayhem",
    "category": "action",
    "genre": "Adventure/Action",
    "description": "Help the girls get ready while saving the city.",
    "thumbnail": "/thumbnails/game-88.jpg",
    "url": "https://lib.gamesmotion.fun/power-puff-girls-morning-mayhem",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2263
  },
  {
    "id": "89",
    "title": "Emberwind",
    "category": "platform",
    "genre": "Action/Platformer",
    "description": "Side-scrolling fantasy game with platforming challenges.",
    "thumbnail": "/thumbnails/game-89.jpg",
    "url": "https://lib.gamesmotion.fun/emberwind",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2293
  },
  {
    "id": "90",
    "title": "Education Activity Guardians Defenders Of Mathematica",
    "category": "puzzle",
    "genre": "Educational/Math",
    "description": "Math-based adventure game in a fantasy setting.",
    "thumbnail": "/thumbnails/game-90.jpg",
    "url": "https://lib.gamesmotion.fun/education-activity-guardians-defenders-of-mathematica",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1727
  },
  {
    "id": "91",
    "title": "Star Wars Rebels Team Tactics",
    "category": "puzzle",
    "genre": "Strategy/Adventure",
    "description": "Solve puzzles using teamwork with Rebels characters.",
    "thumbnail": "/thumbnails/game-91.jpg",
    "url": "https://lib.gamesmotion.fun/star-wars-rebels-team-tactis",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1096
  },
  {
    "id": "92",
    "title": "Henry Danger Gs Dance Machine",
    "category": "arcade",
    "genre": "Rhythm/Music",
    "description": "Rhythm game where players dance to the beat.",
    "thumbnail": "/thumbnails/game-92.jpg",
    "url": "https://lib.gamesmotion.fun/henry-danger-gs-dance-machine",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1452
  },
  {
    "id": "93",
    "title": "Scooby Doo Downhill Dash 2",
    "category": "racing",
    "genre": "Racing/Adventure",
    "description": "Navigate a downhill slope while collecting clues.",
    "thumbnail": "/thumbnails/game-93.jpg",
    "url": "https://lib.gamesmotion.fun/scooby-doo-downhill-dash-2",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1674
  },
  {
    "id": "94",
    "title": "Teen Titans Go Rock N Raven",
    "category": "arcade",
    "genre": "Rhythm/Adventure",
    "description": "Guitar Hero-style rhythm game with Raven.",
    "thumbnail": "/thumbnails/game-94.jpg",
    "url": "https://lib.gamesmotion.fun/teen-titans-go-rock-n-raven",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1528
  },
  {
    "id": "95",
    "title": "Whack A Lemming",
    "category": "arcade",
    "genre": "Arcade/Casual",
    "description": "Fast-tap reaction game featuring lemmings.",
    "thumbnail": "/thumbnails/game-95.jpg",
    "url": "https://lib.gamesmotion.fun/whack-a-lemming",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1981
  },
  {
    "id": "96",
    "title": "Regular Show Trash And Dash",
    "category": "action",
    "genre": "Adventure/Action",
    "description": "Help characters clean up junk and avoid obstacles.",
    "thumbnail": "/thumbnails/game-96.jpg",
    "url": "https://lib.gamesmotion.fun/regular-show-trash-and-dash",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1918
  },
  {
    "id": "97",
    "title": "Teen Titans Go Rumble Bee",
    "category": "action",
    "genre": "Adventure/Action",
    "description": "Dodge and smash obstacles as Beast Boy in bee form.",
    "thumbnail": "/thumbnails/game-97.jpg",
    "url": "https://lib.gamesmotion.fun/teen-titans-go-rumble-bee",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1554
  },
  {
    "id": "99",
    "title": "Tom And Jerry Matching Pairs",
    "category": "puzzle",
    "genre": "Puzzle/Memory",
    "description": "Memory card-matching game with classic animation.",
    "thumbnail": "/thumbnails/game-99.png",
    "url": "https://lib.gamesmotion.fun/tom-and-jerry-matching-pairs",
    "orientation": "landscape",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 2850
  },
  {
    "id": "100",
    "title": "Uncle Grand Vs Aunt Grandma",
    "category": "action",
    "genre": "Action/Fighting",
    "description": "Quirky battle with fun mini-games.",
    "thumbnail": "/thumbnails/game-100.png",
    "url": "https://lib.gamesmotion.fun/uncle-grand-vs-aunt-grandma",
    "orientation": "vertical",
    "requiresSubscription": false,
    "rating": 4.5,
    "plays": 1837
  }
];

export const categories = [
  { id: 'all', name: 'All Games', icon: '🎮' },
  { id: 'action', name: 'Action', icon: '⚡' },
  { id: 'arcade', name: 'Arcade', icon: '🎯' },
  { id: 'puzzle', name: 'Puzzle', icon: '🧩' },
  { id: 'racing', name: 'Racing', icon: '🏎️' },
  { id: 'adventure', name: 'Adventure', icon: '🗺️' },
  { id: 'platform', name: 'Platform', icon: '🏃' }
];

export const getAllGames = () => gamesData;

export const getGamesByCategory = (category) => {
  if (category === 'all') return gamesData;
  return gamesData.filter(game => game.category === category);
};

export const getGameById = (gameId) => {
  return gamesData.find(game => game.id === gameId) || null;
};

export const searchGames = (searchTerm) => {
  if (!searchTerm) return gamesData;
  return gamesData.filter(game => 
    game.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    game.description.toLowerCase().includes(searchTerm.toLowerCase())
  );
};
